var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("Show ranking, with button for how its ranked, modal explainer,")])
}
var staticRenderFns = []

export { render, staticRenderFns }